import { Fragment } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { FileDropZone } from '../../../components/forms/dropzone/fileDropZone.type'
import { MAPA_ICON } from '../../../components/forms/dropzone/FormDropZone'
import { ReporteTareas } from '../models'

type Props = {
  files: ReporteTareas[] | undefined
}

export const ListaDocumentos = ({ files }: Props) => {
  // Adaptador: los reportes de tareas vienen del backend como `ReporteTareas`.
  // Se transforman al shape `FileDropZone` para reutilizar UI/iconografía de dropzone.
  const arrArchivosExistentes = files?.map((r: ReporteTareas) => {
    return {
      id: r.idReporte,
      name: r.nombre,
      isNew: false,
      ext: r.nombre?.split('.').pop(),
      url: r.ruta,
    }
  }) as []

  return (
    <>
      {arrArchivosExistentes?.map((fileDropZone: FileDropZone, index) => (
        <Fragment key={index}>
          <div className='d-flex align-items-center mb-3 justify-content-between'>
            <div className='d-flex align-items-center'>
              <div className='symbol symbol-50px me-5'>
                <span className={`symbol-label bg-light-success`}>
                  <i
                    className={`fa-solid fs-1 m-x1 ${
                      fileDropZone.ext && MAPA_ICON.get(fileDropZone.ext)
                        ? MAPA_ICON.get(fileDropZone.ext)
                        : 'fa-file'
                    } text-success`}></i>
                </span>
              </div>
              <div className='d-flex flex-column text-break'>
                <span className={`text-dark text-hover-primary fs-6 fw-bold `}>
                  {fileDropZone.name}
                </span>
              </div>
            </div>
            <div className='flex-grow-1 ps-3 d-flex justify-content-end'>
              {!fileDropZone.isNew && (
                <OverlayTrigger placement={'top'} overlay={<Tooltip>Ver archivo</Tooltip>}>
                  <a
                    className='btn btn-outline-danger btn-icon btn-circle'
                    href={fileDropZone.url}
                    target='_blank'
                    rel='noopener noreferrer'>
                    <i className='fa-solid fa-arrow-up-right-from-square fs-3'></i>
                  </a>
                </OverlayTrigger>
              )}
            </div>
          </div>
          {index !== arrArchivosExistentes.length - 1 && (
            <div className='separator separator-doted my-4'></div>
          )}
        </Fragment>
      ))}
    </>
  )
}

export default ListaDocumentos
